import { QuestionCircleOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Tooltip, Modal } from "antd";
import React, { useCallback, useContext, useState } from "react";
import { OtsideClickClosingWrapper } from "../../../common/EmojiReactionPicker/OtsideClickClosingWrapper";
import JoditTextEditor from "../../../common/JoditEditor/JoditTextEditor";
import ConditionTree from "../../../components/TaskBluePrints/Criteria/TreeNode";
import { Col } from "reactstrap";
import AwsServerService from "../../../common/util/AwsServerService";
import './TaskFlowStatus.css'
import { AppDataRequired } from "../../../App";
import { useSelector } from "react-redux";
import _ from "lodash";

const SingleTransition = ({ button,criteriaFieldGroups, disabled, getStyleObj, onClickButton, onCloseCallback, taskModalState,
  allCacheRoles,
  lookUpDeal,
  allCacheUserRoles,
  taskData,
  transitionEmails
 }) => {
  const [popConfirmVisible, setPopConfirmVisible] = useState(false);
  const { AllUsers } = useContext(AppDataRequired);
  const moduleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
  const [inputValue, setInputValue] = useState('');
  const [missingRoleUserLabel, setMissingRoleUserLabel] = useState({Roles:[],Attachments:[]});
  // const [missingRoleUsers, setMissingRoleUsers] = useState([]);
  const handleCancel = () => {
    setPopConfirmVisible(false);
    setInputValue('');
  };
  const handleConfirm = () => { 

    let data = { ...button, comment: inputValue }
    onClickButton(data);
    setPopConfirmVisible(false);
    onCloseCallback();
    setInputValue('');
  };
  const GetAutomationData = () => {
    if (taskData.TaskFlowId) {
      let data=transitionEmails?.filter(r=>r.TransitionEdgeId==button?.key);
       if(data && data.length>0){
           
          let RoleUserNotFound = false;
          let MissingRoleUserIds = [];
          let RoleUserId = [];
          let MissingRoleLabel = {Roles:[],Attachments:[]};
          let unassignedRoles = []; 
          data.forEach((Address) => {
            const processAddress = (addressList, type) => {
              addressList?.forEach((addr) => {
                if (addr?.AttendeeType === "Role") {
                  let roleId = addr?.[type];
                  // RoleUserId.push(roleId); 
                  let roleDataList = allCacheRoles?.filter((e) => e.ROWID == roleId) || []; 
                  if (roleDataList.length > 0) {
                    let roleHasUser = false;
                    let RoleUserData={}
                    roleDataList.forEach((roleData) => {
                      let userId = null;
                      let email = null;
                      let associatedData = {};
                          RoleUserData={
                            UserName:roleData?.RoleName,
                            UserType:roleData?.RoleType
                          }
                      if (roleData.RoleType === "Deal") {
                        userId = allCacheUserRoles?.find(
                          (el) => el.RoleId == roleId && el.ProjectId == lookUpDeal?.Deal_Name
                        )?.UserId;
                        associatedData = { type: "Deal", projectId: lookUpDeal?.Deal_Name };
                      } else if (roleData.RoleType === "Account") {
                        userId = allCacheUserRoles?.find(
                          (el) => el.RoleId == roleId && el.ProjectId == lookUpDeal?.Account_Name?.id
                        )?.UserId;
                        associatedData = { type: "Account", projectId: lookUpDeal?.Account_Name?.id };
                      } else if (roleData.RoleType === "Zoho") {
                        email = AllUsers?.find((e) => e.zuid == roleId)?.email;
                      } else if (roleData.Role === "Vendor") {
                        userId = allCacheUserRoles?.find(
                          (el) => el.RoleId == roleId && el.ProjectId == lookUpDeal?.Deal_Name
                        )?.UserId;
                        associatedData = { type: "Vendor", projectId: lookUpDeal?.Deal_Name };
                      } 
                      if (userId) {
                        email = Object.values(moduleContacts || {}).flat()
                          ?.find((k) => k.id == userId)?.Email;
                      } 
                      if (email) {
                        roleHasUser = true;
                      } else {
                        unassignedRoles.push({ RoleId: roleId, ...associatedData });
                      }
                    }); 
                    if (!roleHasUser) {
                      RoleUserNotFound = true;
                      MissingRoleLabel.Roles.push(RoleUserData)
                      MissingRoleUserIds.push(roleId);
                    }
                  }
                }
              });
            }; 
            processAddress(Address?.ToAddress, "ToAddress");
            processAddress(Address?.BccAddress, "BccAddress");
            processAddress(Address?.CcAddress, "CcAddress");
            if(Address?.Attachments && Address?.Attachments?.length>0){
              Address.Attachments.forEach(attachmnt=>{
                let fieldObj=taskData.TaskFlowObject?.InputFields?.find(elmnt=>elmnt.id==attachmnt.id);
                if(fieldObj && _.isEmpty(fieldObj.value)){
                  MissingRoleLabel.Attachments.push(fieldObj.Name);
                }
              })
            }
          }); 
          if(MissingRoleLabel.Roles.length==0 && MissingRoleLabel.Attachments.length==0){
            setPopConfirmVisible(true);
          }else{
            setMissingRoleUserLabel(MissingRoleLabel); 
          }
          // setMissingRoleUsers(MissingRoleUserIds);
          
        }else{
          setPopConfirmVisible(prev => !prev);
        }
    }
  };
  
  const checkForRequiredFields = ()=>{
    return (
    <Modal
        title="Missing Automation Data" 
        maskClosable={false} 
        className="requiredMissingFields"
        open={missingRoleUserLabel.Roles.length>0 || missingRoleUserLabel.Attachments.length>0}
        // onOk={()=>setMissingRoleUserLabel({Roles:[],Attachments:[]})}
        onCancel={()=>setMissingRoleUserLabel({Roles:[],Attachments:[]})}
        // onClose={()=>setMissingRoleUserLabel({Roles:[],Attachments:[]})}
        footer={()=>[<Button key="Cancel" onClick={() =>{
          setMissingRoleUserLabel({ Roles: [], Attachments: [] })
        }}>Cancel</Button>,
        <Button key="Ok" onClick={() =>{
          setMissingRoleUserLabel({ Roles: [], Attachments: [] })
          setPopConfirmVisible(prev => !prev); 
        }}>Proceed</Button>]}
      >
        <div className="fieldsRendererClassMainWrapper">
          <div>
          {missingRoleUserLabel.Roles.length>0 && <span className="headingMsg">| Missing Roles for Automation </span>}
          <div className="fieldsRendererClass">
            {missingRoleUserLabel.Roles.map((e,index)=>(
              <ul key={index} className="customList">
              <li>{e?.UserType + "'s " + e?.UserName}</li>
              </ul>
            ))}
            </div>
            </div>
            <div>
            {missingRoleUserLabel.Attachments.length>0 && <span className="headingMsg">| Missing Attachments from fields for Automation </span>}
            <div className="fieldsRendererClass">
            {missingRoleUserLabel.Attachments.map((e,index)=>(
                  <ul key={index} className="customList">
                  <li>{e}</li>
                  </ul> 
            ))}
            </div>
          </div>
        </div>
      </Modal>
    )
  }
  const getCriteriaRows = useCallback(criteria=>{ 
    //  
    if(criteria && criteria.length>0){
      return <>
        <ConditionTree criteriaFieldGroups={criteriaFieldGroups} criteria={criteria}/>
      </>
    }else{
      return <></>
    }
    
  },[button,criteriaFieldGroups])

  return (
    // <OtsideClickClosingWrapper
    //     avoidClasses={"transitionCommentPopup"}
    //     close={e=>{
    //         setPopConfirmVisible(false);
    //         onCloseCallback();
    //         setInputValue('');
    //     }}
    // >
    <>
    {checkForRequiredFields()}
    <Popconfirm
      // disabled={inputField.Type != "PICKLIST"}
      key={button.id}
      className={"transitionCommentPopup"}
      overlayClassName={"transitionCommentPopup"}
      open={popConfirmVisible}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      destroyTooltipOnHide
      okText="Yes"
      placement="topLeft"
      cancelText="No"
      title={<div>
        <span style={{ fontWeight: "700" }}>Confirm transition change?</span>
        <JoditTextEditor
          id={"transition"}
          setEmailContent={setInputValue}
        />
      </div>}
      icon={
        <QuestionCircleOutlined
          style={{
            color: "red",
          }}
        />
      }
    >
      {/* <Tooltip destroyTooltipOnHide={true} overlayClassName="Criteria-Tooltip" overlayStyle={!disabled && { visibility: "hidden",width:"auto" }} title={<Col className="p0m0">
        <span>Criteria</span>
        {getCriteriaRows(button?.Criteria)}
        
      </Col>} style={!disabled && { visibility: "hidden" }} > */}
        {!(disabled || taskModalState?.action == "create") && <Button
          disabled={(disabled || taskModalState?.action == "create")}
          style={{ marginRight: "8px", ...getStyleObj(button), cursor: `${(disabled || taskModalState?.action == "create") ? "not-allowed" : "pointer"}`, opacity: `${disabled ? 0.5 : 1}` }}
          onClick={() => { 
            GetAutomationData();
            // setPopConfirmVisible(prev => !prev);
          }}
        >
          {button.label}
        </Button>}
      {/* </Tooltip> */}
    </Popconfirm>
    </>
    // </OtsideClickClosingWrapper>
  );
  
};

export default SingleTransition;
